export default __webpack_public_path__ + "static/remote-management-7538d1c371cb56d4e8c86dffafc3038f.png";